import React from "react";

const Dashboard = () => {
  return (
    <div className="overflow-scroll h-[100%] p-4">
      <h1 className="text-2xl font-bold">Dashboard Content</h1>
    </div>
  );
};

export default Dashboard;
